// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/form.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Image, ImageJson } from "./common_pb";
import { file_bundles_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bundles/v1/form.proto.
 */
export const file_bundles_v1_form: GenFile = /*@__PURE__*/ fileDesc("ChVidW5kbGVzL3YxL2Zvcm0ucHJvdG8SCmJ1bmRsZXMudjEiZAoIRm9ybURhdGESDAoEbmFtZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRISCgZwaG90b3MYAyADKAlCAhgBEiEKBmltYWdlcxgFIAMoCzIRLmJ1bmRsZXMudjEuSW1hZ2ViBnByb3RvMw", [file_bundles_v1_common]);

/**
 * @generated from message bundles.v1.FormData
 */
export type FormData = Message<"bundles.v1.FormData"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * @generated from field: repeated string photos = 3 [deprecated = true];
	 * @deprecated
	 */
	photos: string[];

	/**
	 * @generated from field: repeated bundles.v1.Image images = 5;
	 */
	images: Image[];
};

/**
 * @generated from message bundles.v1.FormData
 */
export type FormDataJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * @generated from field: repeated string photos = 3 [deprecated = true];
	 * @deprecated
	 */
	photos?: string[];

	/**
	 * @generated from field: repeated bundles.v1.Image images = 5;
	 */
	images?: ImageJson[];
};

/**
 * Describes the message bundles.v1.FormData.
 * Use `create(FormDataSchema)` to create a new message.
 */
export const FormDataSchema: GenMessage<FormData, { jsonType: FormDataJson }> = /*@__PURE__*/ messageDesc(file_bundles_v1_form, 0);
